import mapboxgl from 'mapbox-gl';
import * as m from "./mapInit";
import $ from "jquery";

//EACH LAYER
m.toggleableLayerIds.forEach(function(layerName, i){

  let popupHover = new mapboxgl.Popup({
    className: 'hover',
    closeButton: false,
    closeOnClick: false
  });

  // HOVER POPUP
  let zoom;
  let mousePos;
  let coordinates;
  m.map.on('mousemove', m.toggleableLayerIds[i], function(e) {
    zoom = m.map.getZoom();
    mousePos = new mapboxgl.LngLat(e.lngLat.lng, e.lngLat.lat+(0.5/zoom));
    // Change the cursor style as a UI indicator.
    m.map.getCanvas().style.cursor = 'pointer';
    
    coordinates = e.features[0].geometry.coordinates[0].slice();
    let description = e.features[0].properties['nuts-3-label'] + "</br>"
    + e.features[0].properties['nuts-0-label'];
    // + e.features[0].properties['nuts2-label'] + "</br>"

    // Ensure that if the map is zoomed out such that multiple
    // copies of the feature are visible, the popup appears
    // over the copy being pointed to.
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }
    // Populate the popup and set its coordinates
    // based on the feature found.
    popupHover.setLngLat(mousePos)
    .setHTML(description)
    .addTo(m.map);
    });

  m.map.on('mouseleave', m.toggleableLayerIds[i], function() {
    m.map.getCanvas().style.cursor = '';
    popupHover.remove();
  });

}); //each layer